import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { RIGHT_RAIL_WIDTH } from './rightRailTokens';

/**
 * Sticky secondary column used next to a primary feed/browse column (md+).
 * Stacks under the main column on small screens.
 *
 * `stickyTop` defaults to 0 so the rail lines up with the feed compose card.
 * (Avoid nesting another sticky wrapper with a non-zero top — that offsets the rail at rest.)
 */
export default function RightRail({
  children,
  testId = 'right-rail',
  width = RIGHT_RAIL_WIDTH,
  stickyTop = 0,
}) {
  return (
    <Box
      data-testid={testId}
      sx={{
        width: { xs: '100%', md: width },
        flex: { xs: '1 1 auto', md: `0 0 ${width}px` },
        position: { md: 'sticky' },
        top: { md: stickyTop },
        alignSelf: { md: 'flex-start' },
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        mt: 0,
        pt: 0,
      }}
    >
      {children}
    </Box>
  );
}

RightRail.propTypes = {
  children: PropTypes.node,
  testId: PropTypes.string,
  width: PropTypes.number,
  stickyTop: PropTypes.number,
};
